import themeColors from '../theme/apim-chart-colors';

const CONTINENTS = {
  AF: 'Africa',
  AS: 'Asia',
  EU: 'Europe',
  OC: 'Oceania',
  NA: 'North America',
  SA: 'South America',
  CN: 'China',
};

const CLOUD_COLOR_MAP = {
  AWS: themeColors.COLOR_AWS,
  AZURE: themeColors.COLOR_AZURE,
  GOOGLE: themeColors.COLOR_GOOGLE,
  IBM: themeColors.COLOR_IBM,
  CHINAVPS: themeColors.COLOR_CHINAVPS,
  OPENHOST: themeColors.COLOR_OPENHOST,
  OTHER: themeColors.COLOR_OTHER,
  AKAMAI: themeColors.COLOR_AKAMAI,
};

const CLOUD_HEX_COLOR_MAP = {
  AWS: '#e3c179',
  AZURE: '#18a8ca',
  GOOGLE: '#5ed499',
  IBM: '#f37c7c',
  CHINAVPS: '#924cbf',
  OPENHOST: '#d9f469',
  OTHER: '#b8b8b8',
  AKAMAI: '#FB9934',
};

const CLOUDS = {
  AWS: { name: 'AWS', color: 'var(--aws)' },
  AZURE: { name: 'Azure', color: 'var(--azure)' },
  GOOGLE: { name: 'Google', color: 'var(--google)' },
  IBM: { name: 'IBM', color: 'var(--ibm)' },
  CHINAVPS: { name: 'ChinaVPS', color: 'var(--chinavps)' },
  OPENHOST: { name: 'OpenHost NZ', color: 'var(--openhost)' },
  OTHER: { name: 'Other', color: 'var(--grey)' },
  AKAMAI: { name: 'Akamai', color: 'var(--akamai)' },
};

export { CONTINENTS, CLOUDS, CLOUD_COLOR_MAP, CLOUD_HEX_COLOR_MAP };
